export const NAVIGATION_NS = 'navigation';

export const i18n = {
  en: {
    export: 'Export',
    home: 'Home',
    mfmMonitoring: 'MFM Monitoring',
    print: 'Print',
  },
};
